var activeTabs = {

	activeTab: null,
	element: null,

	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {

		activeTabs.element = target.querySelector('[data-nav-tabs]') || null;
		activeTabs.activeTab = activeTabs.element?.dataset?.navTabsActive || 1;

		if (activeTabs.element !== null) {
			activeTabs.initEvents(activeTabs.element);
			activeTabs.setActiveTab(activeTabs.element, activeTabs.activeTab);
		}

	},

	/**
	 * Init events
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	initEvents: function(target) {
		target.addEventListener('click', function(event) {
			for (var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode) {
				if (eventTarget.matches('[data-nav-tabs-click] li[data-nav-tabs-item] a')) {
					if (!activeTabs.checkIfAllowed(event)) {
						event.preventDefault();
					}
					break;
				}
			}
		}, false);
	},

	/**
	 * Set active tab
	 *
	 * @param {object} target
	 * @param {number} stap
	 *
	 * @returns {void}
	 */
	setActiveTab: function(target, stap) {
		const activeTab = target.querySelectorAll('[data-nav-tabs-item="' + stap + '"] a');
		activeTab?.forEach(element => element.classList.add('active'));
	},

	/**
	 * Check if allowed
	 *
	 * @param {object} event
	 *
	 * @returns {boolean}
	 */
	checkIfAllowed: function(event) {
		const urlArray = event.target.closest('li')?.querySelector('a')?.getAttribute('href')?.split('/');
		if (typeof urlArray == 'object' && urlArray[urlArray.length - 1] > activeTabs.activeTab) {
			return false;
		}
		return true;
	},

	/**
	 * Voert de init functie uit van de geselecteerde tab als er een script voor gedefinieerd is
	 *
	 * @param tabScripts
	 * @param tabIndex
	 */
	initTab(tabScripts, tabIndex = null) {
		tabIndex = tabIndex || activeTabs.getTabIndex();
		const index = (tabIndex - 1);
		if (typeof tabScripts[index] !== 'undefined') {
			tabScripts[index].init();
		};
	},

	/**
	 * Verkrijgt de tab index uit de DOM
	 *
	 * @param [targetElement=null]
	 *
	 * @returns {string}
	 */
	getTabIndex(targetElement = null) {
		const element = targetElement || document.body;
		const tabIndex = element.querySelector('[data-nav-tabs-active]').dataset.navTabsActive || null;
		if (tabIndex !== null) {
			return parseInt(tabIndex);
		}
		return false;
	}

};

export default activeTabs;
